import { Box, Button, Stack, Textarea } from "@mui/joy";
import * as React from "react";
import { serverHost } from "./const";

const AddDeviceView: React.FC = () => {
  const submit = async (text: string) => {
    const url = `http://${serverHost}/device?id=${text.trim()}`;

    try {
      const resp: Response = await fetch(url, {
        method: "POST",
      });
      if (!resp.ok) {
        console.log(await resp.text());
        alert("添加失败,请联系管理员");
        return;
      } else {
        alert("添加成功");
      }
    } catch (error) {
      console.log(error);
      alert("添加失败,请联系管理员");
      return;
    }
  };
  return (
    <Box sx={{ justifyContent: "center", display: "flex" }}>
      <form
        style={{ width: "100%", display: "flex", justifyContent: "center" }}
        onSubmit={(event) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          let t = formData.get("deviceCode")?.toString();
          if (!t) {
            alert("请输入合法设备码");
            return;
          }
          submit(t);
        }}>
        <Stack spacing={3} width='70%'>
          <Textarea name='deviceCode' placeholder='请输入设备码' required minRows={3}></Textarea>
          <Button type='submit'>添加设备码</Button>
        </Stack>
      </form>
    </Box>
  );
};

export default AddDeviceView;
